<div class="one" fxLayout="column" [formGroup]="MatterConveyancingDetailsForm">
  <div fxLayout="row" fxFlex="1 0 auto" class="checkbox-row">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PROPERTYTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PROPERTYTYPE),
      }"
    >
      <mat-label>Property Type</mat-label>
      <mat-select
        formControlName="PROPERTYTYPE"
        matTooltip="{{ toolTipList ? toolTipList.PROPERTYTYPE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      >
        @for (propertyTypetatusLookup of propertyTypeLookupsData; track propertyTypetatusLookup) {
          <mat-option value="{{ propertyTypetatusLookup.LOOKUPGUID }}">
            {{ propertyTypetatusLookup.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-select>
      @if (testBool && toolTipList.PROPERTYTYPE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PROPERTYTYPE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PROPERTYTYPE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-checkbox class="checkbox-width" formControlName="ELIGIBLEFORSTAMPDUTYREDUCTION">
      Eligible For Stamp Duty Reduction
    </mat-checkbox>
  </div>
  <div fxLayout="row" class="checkbox-row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-checkbox class="checkbox-width" formControlName="FIRSTHOMEOWNERSGRANT">
      First Home Owners Grant
    </mat-checkbox>
    <mat-checkbox class="checkbox-width" formControlName="NEWHOMEGRANT">
      New Home Grant
    </mat-checkbox>
    <mat-checkbox class="checkbox-width" formControlName="EXEMPTFROMPREMIUMPROPERTYDUTY">
      Exempt From Premium Property Duty
    </mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="checkbox-row">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ELIGIBLEPURCHASERPERCENTAGE),
        'has-warning': $safeNavigationMigration(
          errorWarningData.Warning?.ELIGIBLEPURCHASERPERCENTAGE
        ),
      }"
    >
      <mat-label>Eligible Purchaser Percentage</mat-label>
      <input
        matInput
        formControlName="ELIGIBLEPURCHASERPERCENTAGE"
        matTooltip="{{ toolTipList ? toolTipList.ELIGIBLEPURCHASERPERCENTAGE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.ELIGIBLEPURCHASERPERCENTAGE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ELIGIBLEPURCHASERPERCENTAGE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ELIGIBLEPURCHASERPERCENTAGE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-checkbox class="checkbox-width" formControlName="FOREIGNPURCHASER">
      Foreign Purchaser
    </mat-checkbox>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <div fxLayout="column" fxFlex="50">
      <mat-form-field
        appearance="outline"
        fxFlex="100"
        class="mb-3 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.DUTIBLEAMOUNT),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DUTIBLEAMOUNT),
        }"
      >
        <mat-label>Dutible Amount</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.DUTIBLEAMOUNT?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="DUTIBLEAMOUNT"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.DUTIBLEAMOUNT) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.DUTIBLEAMOUNT.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList ? $safeNavigationMigration(toolTipList?.DUTIBLEAMOUNT?.COPYVALUE) : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="100"
        class="mb-3 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.ADDITIONALDUTY),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ADDITIONALDUTY),
        }"
      >
        <mat-label>Additional Duty</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.ADDITIONALDUTY?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="ADDITIONALDUTY"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.ADDITIONALDUTY) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.ADDITIONALDUTY.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.ADDITIONALDUTY?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="100"
        class="mb-3 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.LODGEMENTFEE),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.LODGEMENTFEE),
        }"
      >
        <mat-label>Lodgement Fee</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.LODGEMENTFEE?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="LODGEMENTFEE"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.LODGEMENTFEE) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.LODGEMENTFEE.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList ? $safeNavigationMigration(toolTipList?.LODGEMENTFEE?.COPYVALUE) : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="100"
        class="mb-3 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.ADVALOREMFEE),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ADVALOREMFEE),
        }"
      >
        <mat-label>Ad Valorem Fee</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.ADVALOREMFEE?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="ADVALOREMFEE"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.ADVALOREMFEE) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.ADVALOREMFEE.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList ? $safeNavigationMigration(toolTipList?.ADVALOREMFEE?.COPYVALUE) : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="100"
        class="mb-3 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.TOTALREGISTRATIONFEES),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TOTALREGISTRATIONFEES),
        }"
      >
        <mat-label>Total Registration Fees</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.TOTALREGISTRATIONFEES?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="TOTALREGISTRATIONFEES"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.TOTALREGISTRATIONFEES) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.TOTALREGISTRATIONFEES.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.TOTALREGISTRATIONFEES?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
    </div>
    <div fxLayout="column" fxFlex="50" class="other-field-37">
      <mat-form-field
        appearance="outline"
        fxFlex="100"
        class="mb-3 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.STAMPDUTYAMOUNT),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STAMPDUTYAMOUNT),
        }"
      >
        <mat-label>Stamp Duty</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.STAMPDUTYAMOUNT?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="STAMPDUTYAMOUNT"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.STAMPDUTYAMOUNT) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.STAMPDUTYAMOUNT.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.STAMPDUTYAMOUNT?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="100"
        class="mb-3 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.STAMPDUTYDUEDATE),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STAMPDUTYDUEDATE),
        }"
      >
        <mat-label>Stamp Duty Due</mat-label>
        <input
          (dateInput)="CommanDatePickerClick('input', $event, 'STAMPDUTYDUEDATE')"
          matTooltip="{{ toolTipList ? toolTipList.STAMPDUTYDUEDATETEXT?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="STAMPDUTYDUEDATETEXT"
          (dateChange)="CommanDatePickerClick('input', $event, 'STAMPDUTYDUEDATE')"
          matInput
          name="StampDutyDue"
          [matDatepicker]="StampDutyDue"
        />
        <mat-datepicker-toggle matSuffix [for]="StampDutyDue"></mat-datepicker-toggle>
        <mat-datepicker #StampDutyDue></mat-datepicker>
        @if (testBool && toolTipList.STAMPDUTYDUEDATE) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.STAMPDUTYDUEDATE.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.STAMPDUTYDUEDATE?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="100"
        class="mb-3 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.STAMPDUTYPAIDDATE),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STAMPDUTYPAIDDATE),
        }"
      >
        <mat-label>Stamp Duty Paid</mat-label>
        <input
          (dateInput)="CommanDatePickerClick('input', $event, 'STAMPDUTYPAIDDATE')"
          matTooltip="{{ toolTipList ? toolTipList.STAMPDUTYPAIDDATE?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="STAMPDUTYPAIDDATETEXT"
          (dateChange)="CommanDatePickerClick('input', $event, 'STAMPDUTYPAIDDATE')"
          matInput
          name="StampDutyPaid"
          [matDatepicker]="StampDutyPaid"
        />
        <mat-datepicker-toggle matSuffix [for]="StampDutyPaid"></mat-datepicker-toggle>
        <mat-datepicker #StampDutyPaid></mat-datepicker>
        @if (testBool && toolTipList.STAMPDUTYPAIDDATE) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.STAMPDUTYPAIDDATE.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.STAMPDUTYPAIDDATE?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="100"
        class="mb-3 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.OSRRECEIPTNO),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.OSRRECEIPTNO),
        }"
      >
        <mat-label>OSR Receipt No</mat-label>
        <input
          matInput
          matTooltip="{{ toolTipList ? toolTipList.OSRRECEIPTNO?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="OSRRECEIPTNO"
        />
        @if (testBool && toolTipList.OSRRECEIPTNO) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.OSRRECEIPTNO.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList ? $safeNavigationMigration(toolTipList?.OSRRECEIPTNO?.COPYVALUE) : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
    </div>
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    fxFlex="1 0 auto"
    class="form_field_div_taxable checkbox-row"
  >
    <mat-checkbox class="checkbox-width1" formControlName="LANDTAXADJUSTABLE">
      Land Tax Adjustable
    </mat-checkbox>
    <mat-checkbox class="checkbox-width1" formControlName="MARGINSCHEME">
      Margin Scheme
    </mat-checkbox>
    <mat-form-field appearance="outline" fxFlex="40" class="pr-1">
      <mat-label>Is taxable Supply</mat-label>
      <mat-select formControlName="ISTAXABLESUPPLYFORGST">
        <mat-option value="No">No</mat-option>
        <mat-option value="Yes">Yes</mat-option>
        <mat-option value="To some extent">To some extent</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxFlex="100">
    <strong>
      This sale is not a taxable supply because (one or more of the following may apply) the sale is
    </strong>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <div fxLayout="column" fxFlex="100">
      <mat-checkbox fxFlex="100" formControlName="SECTION9_5_B" class="wrap-label">
        not made in the course or furtherance of an enterprise that the vendor carries on (section
        9-5(b)) by a vendor who is neither registered nor required to be registered for GST (section
        9-5(d))
      </mat-checkbox>
      <mat-checkbox fxFlex="100" formControlName="SECTION9_5_D" class="wrap-label">
        by a vendor who is neither registered nor required to be registered for GST (section 9-5(d))
      </mat-checkbox>
      <mat-checkbox fxFlex="100" formControlName="SECTION38_325" class="wrap-label">
        GST-free because the sale is the supply of a going concern under section 38-325
      </mat-checkbox>
      <mat-checkbox fxFlex="100" formControlName="SUBDIVISION38_O" class="wrap-label">
        GST-free because the sale is subdivided farm land or farm land supplied for farming under
        Subdivision 38-O
      </mat-checkbox>
      <mat-checkbox fxFlex="100" formControlName="INPUTTAXED" class="wrap-label">
        Input taxed because the sale is of eligible residential premises (sections 40-65, 40-75(2)
        and 195-1)
      </mat-checkbox>
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-checkbox fxFlex="100" formControlName="MUSTMAKERWPAYMENT">
      Must make Residential Withholding Payment
    </mat-checkbox>
  </div>
</div>
